import router from "@/router";
import { getError } from "@/utils/helpers";
import AuthService from "@/services/AuthService";
import Vue from "vue";


export const namespaced = true;

export const state = {
  user: null,
  loading: false,
  error: null,
};

export const mutations = {
  SET_USER(state, user) {
    state.user = user;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
};

export const actions = {
  clearTimers() {
    if (window.tokenRefreshInterval) {
      clearInterval(window.tokenRefreshInterval);
      window.tokenRefreshInterval = null;
    }
    if (window.idleTimeout) {
      clearInterval(window.idleTimeout);
      window.idleTimeout = null;
    }
  },
  logout({ commit, dispatch }) {
    dispatch("clearTimers");
    return AuthService.logout()
      .then(() => {
        commit("SET_USER", null);
        dispatch("setGuest", { value: "isGuest" });
        
        if (router.currentRoute.name !== "login") {
          router.push({ path: "/user/login" });
        }
      })
      .catch((error) => {
        commit("SET_ERROR", getError(error));
      });
  },
  async getAuthUser({ commit }) {
    commit("SET_LOADING", true);
    try {
      const response = await AuthService.getAuthUser();
      commit("SET_USER", response.data);
      commit("SET_LOADING", false);
      return response.data;
    } catch (error) {
      commit("SET_LOADING", false);
      commit("SET_USER", null);
      commit("SET_ERROR", getError(error));
      router.push({ name: "login", params: { error: error.response.data.error } });
    }
  },
  setGuest(context, { value }) {
    window.localStorage.setItem("guest", value);
  },
  async getClients({ commit }) {
    commit("SET_LOADING", true);
    try {
      const response = await AuthService.getAllClients();
      commit("SET_LOADING", false);
      return response.data.users;
    } catch (error) {
      commit("ALL_CLIENTS", null);
      commit("SET_ERROR", getError(error));
    }
  },
  async refreshToken({ dispatch }) {
    try {
      const response = await AuthService.refreshToken();
      // This will be automatically stored in cookie by Laravel response
      return response;
    } catch (error) {
      Vue.$toast.open({
        message: "Your session has expired. Please log in again.",
        type: "error",
        duration: 5000,
        position: "top-right",
      });
      // Logout on failed refresh
      await dispatch("logout");
      throw error;
    }
  },
};

export const getters = {
  authUser: (state) => {
    return state.user;
  },
  userRoles: (state) => {
    return state.user ? state.user.roles : false;
  },
  error: (state) => {
    return state.error;
  },
  loading: (state) => {
    return state.loading;
  },
  loggedIn: (state) => {
    return !!state.user;
  },
  guest: () => {
    const storageItem = window.localStorage.getItem("guest");
    if (!storageItem) return false;
    if (storageItem === "isGuest") return true;
    if (storageItem === "isNotGuest") return false;
  },
};